module.exports = __webpack_public_path__ + "img/RU.182478bc.svg";